module.exports = __webpack_public_path__ + "static/img/banner_table_bg.4f56fec.png";